import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Link from "../../link";

/**
 * Representation of the condition for {@link PolicyResource}.
 *
 * @remarks
 * Note this representation does not provide access to condition direct entities which are present in internal
 * system model.
 */
@JsonObject()
export class ConditionResource {
    /**
     * The condition is met for entities that are direct or indirect descendants of the entities with the
     * specified links.
     * The entities are combined using the "OR" operator.
     */
    @JsonProperty("entities")
    @JsonElementType(Link)
    entities: Array<Link> = [];

    /**
     * The condition is met for entities that are direct descendants of the entities with the specified links.
     * The entities are combined using the "OR" operator.
     */
    @JsonProperty("direct_entities")
    @JsonElementType(Link)
    directEntities: Array<Link> = [];
}
